import React, { ReactElement } from 'react';
import styled from 'styled-components';

const StyledFloatLabelSelect = styled.div`
  --color__accent: var(--primary-color);
  --input__border: ${({ theme }) => theme.colors.border.gray};
  --input__border--hover: ${({ theme }) => theme.colors.border.grayDarker};
  --label__color: ${({ theme }) => theme.colors.text.body};

  position: relative;

  .floating-select {
    padding: 1.2em 2em 0.4em 0.5em;
    font-size: inherit;
    border: 0;
    border-bottom: 0.1em solid var(--input__border);
    width: 100%;
      background-color: transparent;
    color: var(--label__color);
    appearance: none;
    cursor: pointer;
    text-align: left;
    text-align-last: left;
    
    &:focus {
   border-color: var(--primary-color);
    outline: 0;
    box-shadow: 0 0 0 0.2rem hsla(var(--h), var(--s), var(--l), 30%);

    html[data-color-mode='dark'] & {
      background-color: var(--color-neutral-contrast-00);
    }
    }
      html[data-color-mode='dark'] & {
    --input-bg: var(--color-neutral-contrast-02);
  }
  }

  &:hover .floating-select {
    border-bottom-color: var(--input__border--hover);
  }

  /* Arrow */
  .floating-select {
    background-image: url("data:image/svg+xml;utf8,<svg fill='gray' height='20' viewBox='0 0 20 20' width='20'><path d='M5 7l5 5 5-5z'/></svg>");
    background-repeat: no-repeat;
    background-position: right 0.2em center;
    background-size: 1em;
  }

  .floating-label {
    position: absolute;
    left: -8px;
    top: 2.7em;
    font-weight: 500;
    pointer-events: none;
    transform-origin: left top;
  }

  .floating-label::before {
    content: attr(data-content);
    display: inline-block;
    color: var(--label__color);
    transform: translate3d(0, -3.12em, 0) scale3d(0.82, 0.82, 1);
    transition: transform 0.2s ease, color 0.2s ease;
  }

  .floating-select:focus + .floating-label::before {
    color: var(--color__accent);
  }
`;

type Option = {
  label: string;
  value: string;
};

type FloatLabelSelectProps = {
  label: string;
  value: string;
  options: Option[];
  onChange: (value: string) => void;
  style?: React.CSSProperties;
};

function FloatLabelSelect({
  label,
  value,
  options,
  onChange,
  style,
}: FloatLabelSelectProps): ReactElement {
  const fieldID = label.replace(/\s/g, '').toLowerCase();

  return (
    <StyledFloatLabelSelect style={style} title={label}>
      <select
        id={fieldID}
        className="floating-select"
        value={value}
        onChange={e => onChange(e.target.value)}
      >
        {options.map(opt => (
          <option key={opt.value} value={opt.value}>
            {opt.label}
          </option>
        ))}
      </select>


      <label htmlFor={fieldID} className="floating-label" data-content={label}>
        <span className="sr-only">{label}</span>
      </label>
    </StyledFloatLabelSelect>
  );
}

export default FloatLabelSelect;
